import { render, staticRenderFns } from "./CreateBank.vue?vue&type=template&id=33e51316&scoped=true&"
import script from "./CreateBank.vue?vue&type=script&lang=js&"
export * from "./CreateBank.vue?vue&type=script&lang=js&"
import style0 from "./CreateBank.vue?vue&type=style&index=0&id=33e51316&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e51316",
  null
  
)

export default component.exports